export const seoConfig = {
  home: {
    title: "Cervello Eduverse - Next-Generation Education Ecosystem | School Coaching, Career Development & Entrepreneurship",
    description: "Cervello Eduverse is a future-ready education ecosystem bringing academics, mentorship, and real-world skills together under one premium learning experience. Programs for school students, college students, and entrepreneurs in Hyderabad.",
    keywords: "education, learning, online courses, student development, skill building, career development, entrepreneurship, junior academy, elevare, business lab, school coaching, career guidance, startup development, Hyderabad education, best coaching center Hyderabad, skill development courses, online learning India, career counseling, exam preparation, programming courses, digital marketing, business skills",
    url: "https://cervelloeduverse.com",
    image: "https://cervelloeduverse.com/images/cervello-og-image.jpg",
    canonical: "https://cervelloeduverse.com",
    schemaData: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "EducationalOrganization",
          "@id": "https://cervelloeduverse.com/#organization",
          "name": "Cervello Eduverse",
          "url": "https://cervelloeduverse.com",
          "description": "A future-ready education ecosystem bringing academics, mentorship, and real-world skills together under one premium learning experience.",
          "logo": {
            "@type": "ImageObject",
            "url": "https://cervelloeduverse.com/images/cervello-logo.webp"
          },
          "sameAs": [
            "https://www.facebook.com/cervelloeduverse",
            "https://www.instagram.com/cervello_eduverse",
            "https://www.linkedin.com/company/cervelloeduverse",
            "https://wa.me/918639619079"
          ],
          "areaServed": {
            "@type": "Country",
            "name": "India"
          },
          "founder": {
            "@type": "Person",
            "name": "Mohd. Yaasir Sufiyan",
            "jobTitle": "Founder & CEO"
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Santoshnagar-Saidabad Main road, 5th Floor, Emaan Manzil, Royal Embassy School Lane, beside Success Group of Institutions",
            "addressLocality": "Hyderabad",
            "addressRegion": "Telangana",
            "postalCode": "500059",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 17.3553111,
            "longitude": 78.5057216
          }
        },
        {
          "@type": "WebSite",
          "@id": "https://cervelloeduverse.com/#website",
          "url": "https://cervelloeduverse.com",
          "name": "Cervello Eduverse",
          "description": "A future-ready education ecosystem bringing academics, mentorship, and real-world skills together under one premium learning experience.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              "urlTemplate": "https://cervelloeduverse.com/courses?q={search_term_string}"
            },
            "query-input": "required name=search_term_string"
          }
        }
      ]
    }
  },
  elevare: {
    title: "Cervello Elevare - Career-Focused Education for Students & Young Professionals | Cervello Eduverse",
    description: "Cervello Elevare offers career-focused education for college students and young professionals. Upskill with industry-relevant courses, internships, and portfolio-building programs designed to bridge the gap between academia and industry.",
    keywords: "career education, professional development, student training, industry skills, college students, young professionals, software development, data science, web development, career guidance, internship programs, portfolio building, full stack development, data analytics, data science",
    url: "https://cervelloeduverse.com/elevare",
    image: "https://cervelloeduverse.com/images/elevare-og-image.jpg",
    canonical: "https://cervelloeduverse.com/elevare",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      "name": "Cervello Elevare",
      "url": "https://cervelloeduverse.com/elevare",
      "description": "Career-focused education for college students and young professionals, offering industry-relevant courses, internships, and portfolio-building programs.",
      "logo": "https://cervelloeduverse.com/images/cervello-logo.webp",
      "founder": {
        "@type": "Person",
        "name": "Mohd. Yaasir Sufiyan"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Santoshnagar-Saidabad Main road, 5th Floor, Emaan Manzil, Royal Embassy School Lane, beside Success Group of Institutions",
        "addressLocality": "Hyderabad",
        "addressRegion": "Telangana",
        "postalCode": "500059",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 17.3553111,
        "longitude": 78.5057216
      }
    }
  },
  juniorAcademy: {
    title: "Cervello Junior Academy - Foundation Learning for School Students | Cervello Eduverse",
    description: "Cervello Junior Academy offers specialized coaching for Class 10th and Intermediate students with comprehensive curriculum, EAPCET entrance exam preparation, and personalized mentorship.",
    keywords: "junior academy, school coaching, 10th class, intermediate, EAPCET preparation, academic coaching, foundation programs, student mentorship, education",
    url: "https://cervelloeduverse.com/junior-academy",
    image: "https://cervelloeduverse.com/images/junior-academy-og-image.jpg",
    canonical: "https://cervelloeduverse.com/junior-academy",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      "name": "Cervello Junior Academy",
      "url": "https://cervelloeduverse.com/junior-academy",
      "description": "Specialized coaching for Class 10th and Intermediate students with comprehensive curriculum, EAPCET entrance exam preparation, and personalized mentorship.",
      "logo": "https://cervelloeduverse.com/images/cervello-logo.webp",
      "founder": {
        "@type": "Person",
        "name": "Mohd. Yaasir Sufiyan"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Santoshnagar-Saidabad Main road, 5th Floor, Emaan Manzil, Royal Embassy School Lane, beside Success Group of Institutions",
        "addressLocality": "Hyderabad",
        "addressRegion": "Telangana",
        "postalCode": "500059",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 17.3553111,
        "longitude": 78.5057216
      }
    }
  },
  businessLab: {
    title: "Cervello Business Lab - Entrepreneurship & Business Development Programs | Cervello Eduverse",
    description: "Cervello Business Lab offers comprehensive entrepreneurship and business development programs for aspiring business leaders. Learn to build, scale, and lead successful ventures.",
    keywords: "business lab, entrepreneurship, business development, startup incubation, business planning, market analysis, leadership, venture capital, digital marketing, operations, business mentorship, startup development",
    url: "https://cervelloeduverse.com/business-lab",
    image: "https://cervelloeduverse.com/images/business-lab-og-image.jpg",
    canonical: "https://cervelloeduverse.com/business-lab",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      "name": "Cervello Business Lab",
      "url": "https://cervelloeduverse.com/business-lab",
      "description": "Comprehensive entrepreneurship and business development programs for aspiring business leaders. Learn to build, scale, and lead successful ventures.",
      "logo": "https://cervelloeduverse.com/images/cervello-logo.webp",
      "founder": {
        "@type": "Person",
        "name": "Mohd. Yaasir Sufiyan"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Santoshnagar-Saidabad Main road, 5th Floor, Emaan Manzil, Royal Embassy School Lane, beside Success Group of Institutions",
        "addressLocality": "Hyderabad",
        "addressRegion": "Telangana",
        "postalCode": "500059",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 17.3553111,
        "longitude": 78.5057216
      }
    }
  },
  studentLms: {
    title: "Cervello Student LMS – Coming Soon | Cervello Eduverse",
    description: "Cervello Student LMS is launching soon. A structured learning platform designed for serious academic and career outcomes with recorded sessions, assignments, and progress tracking.",
    keywords: "student lms, learning management system, online learning, student portal, education platform, course management, student dashboard",
    url: "https://cervelloeduverse.com/student-lms",
    image: "https://cervelloeduverse.com/images/lms-og-image.jpg",
    canonical: "https://cervelloeduverse.com/student-lms",
    schemaData: {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      "name": "Cervello Student LMS",
      "url": "https://cervelloeduverse.com/student-lms",
      "description": "A structured learning platform designed for serious academic and career outcomes.",
      "logo": "https://cervelloeduverse.com/images/cervello-logo.webp"
    }
  },
  bookDemo: {
    elevare: {
      title: "Book Cervello Elevare 7-Day Demo Session (₹99) | Cervello Eduverse",
      description: "Register for the Cervello Elevare 7-day demo session for ₹99. Experience our conceptual full-stack tech training, build a mini-project, and test our LMS.",
      keywords: "Cervello Elevare demo, 7-day coding trial, ₹99 software demo class, online coding trial",
      url: "https://cervelloeduverse.com/book-demo?vertical=elevare",
      image: "https://cervelloeduverse.com/images/cervello-og-image.jpg",
      canonical: "https://cervelloeduverse.com/book-demo",
      schemaData: {
        "@context": "https://schema.org",
        "@type": "Action",
        "name": "Book Elevare Demo Session",
        "target": "https://cervelloeduverse.com/book-demo?vertical=elevare"
      },
      faqData: [
        {
          question: "How much does the Elevare 7-day demo session cost?",
          answer: "For Cervello Elevare (career software upskilling), the 7-day demo session costs a nominal fee of ₹99."
        },
        {
          question: "What is included in the Elevare 7-day demo session?",
          answer: "It includes 7 days of structured concept classes, real-world project development guidance, 1-on-1 mentor support, and access to learning materials."
        },
        {
          question: "Are the demo sessions online or offline?",
          answer: "We offer both options: online live interactive classrooms and in-person classroom coaching at our main campus in Hyderabad."
        }
      ]
    },
    junior: {
      title: "Register for Cervello Junior Academy Free 1-Day Demo Class | Cervello Eduverse",
      description: "Book a completely free 1-Day demo class at Cervello Junior Academy. Experience our conceptual coaching for Class 10th and Intermediate MPC/BiPC.",
      keywords: "Cervello Junior Academy demo, free trial class Hyderabad, school coaching demo, Intermediate prep demo",
      url: "https://cervelloeduverse.com/book-demo?vertical=junior",
      image: "https://cervelloeduverse.com/images/junior-academy-og-image.jpg",
      canonical: "https://cervelloeduverse.com/book-demo",
      schemaData: {
        "@context": "https://schema.org",
        "@type": "Action",
        "name": "Register Free Junior Demo Class",
        "target": "https://cervelloeduverse.com/book-demo?vertical=junior"
      },
      faqData: [
        {
          question: "How much does the Junior Academy demo session cost?",
          answer: "The Cervello Junior Academy 1-day demo session is completely free. It allows students to experience our teaching approach and evaluate classes."
        },
        {
          question: "What subjects are evaluated during the demo class?",
          answer: "We evaluate core subjects depending on the stream (Mathematics, Physics, Chemistry for MPC, or Botany, Zoology, Physics, Chemistry for BiPC) and basic concept formulation."
        },
        {
          question: "Are the junior demo classes available in-person?",
          answer: "Yes, we run both online live interactive sessions and offline in-person classroom sessions at our main campus in Hyderabad."
        }
      ]
    },
    business: {
      title: "Request Free Startup Strategy Consultation | Cervello Business Lab",
      description: "Schedule a free startup strategy consultation with Cervello Business Lab partners. Map your business model, MVP development plans, and GTM strategy.",
      keywords: "free business consultation, startup mentoring Hyderabad, business strategy call, MVP advisory",
      url: "https://cervelloeduverse.com/book-demo?vertical=business",
      image: "https://cervelloeduverse.com/images/business-lab-og-image.jpg",
      canonical: "https://cervelloeduverse.com/book-demo",
      schemaData: {
        "@context": "https://schema.org",
        "@type": "Action",
        "name": "Request Startup Consultation",
        "target": "https://cervelloeduverse.com/book-demo?vertical=business"
      },
      faqData: [
        {
          question: "What is included in the startup strategy consultation?",
          answer: "It includes a detailed discussion about your startup idea, operational planning advice, MVP scoping, and alignment with venture funding frameworks."
        },
        {
          question: "Is the startup strategy session free?",
          answer: "Yes, the initial strategy consultation session with our partners is completely free of charge."
        },
        {
          question: "Can we have an in-person meeting for the consultation?",
          answer: "We offer both online video consultations and offline in-person meetings at our Hyderabad office by appointment."
        }
      ]
    },
    general: {
      title: "Book Academic & Career Counseling Session | Cervello Eduverse",
      description: "Schedule a custom counseling session with the Cervello Eduverse academic advisory team to explore our school coaching, career upskilling, and startup programs.",
      keywords: "academic counseling, career guidance Hyderabad, study consultation, Cervello advisory",
      url: "https://cervelloeduverse.com/book-demo?vertical=general",
      image: "https://cervelloeduverse.com/images/cervello-og-image.jpg",
      canonical: "https://cervelloeduverse.com/book-demo",
      schemaData: {
        "@context": "https://schema.org",
        "@type": "Action",
        "name": "Book Counseling Session",
        "target": "https://cervelloeduverse.com/book-demo?vertical=general"
      },
      faqData: [
        {
          question: "Who can book a counseling session?",
          answer: "Students, parents, and working professionals seeking clarity about our coaching classes, tech career bootcamps, or startup programs can book a session."
        },
        {
          question: "How long is the counseling session?",
          answer: "The session typically lasts about 30 to 45 minutes and is tailored to address your specific goals and queries."
        }
      ]
    }
  }
};
